export default __webpack_public_path__ + "static/media/photo5.f85f2e01.jpg";